import { IMapZoneDetailDTO } from "api/swagger/ApiClient";
import * as L from 'leaflet';
import { QueryMemory } from "support/shared_models/query-memory";

export interface MapZonesQueryFilter {
  text: string | null;
  includeArchived: boolean;
}

export interface MapZoneDetailModel {
  data: IMapZoneDetailDTO;
  featureCollectionLayer: L.GeoJSON;
  isDetailed: boolean;
  isHighlighted: boolean;
  isEdited: boolean;
  requestCancelChanges: () => Promise<boolean>;
}

export class MapZonesQueryMemory extends QueryMemory<MapZonesQueryFilter> {
}
